import * as React from 'react'
import { useSelector } from 'react-redux'
import AmazonBookSearchInput from './AmazonBookSearchInput'
import AmazonBookResults from './AmazonBookResults'
import { useAmazonBookSearch } from './hooks/useAmazonBookSearch'
import './style.scss'
import config from '../../config'
import { LinkAmazonAccountWarning } from './LinkAmazonAccount'
import CHANNELS from '../../constants/Channels'
import { AppState } from '../../store'

export const ScanBooks: React.FC = () => {
  const {
    query,
    inputquery,
    books,
    loading,
    loadingSort,
    selectedBookIndex,
    sortDecision,
    handleSelectBook,
    handleSearch,
    handleQueryChange
  } = useAmazonBookSearch()

  const connectedMarketAccounts = useSelector((s: AppState) => s.current.organization.connectedMarketAccounts)
  const connectedMarketAccount = connectedMarketAccounts.find(
    marketAccount => marketAccount.marketId === CHANNELS.AMAZON.id
  )

  const inputRef = React.useRef<HTMLInputElement>(null)

  React.useEffect(() => {
    // When both loading states are false, focus on the input field so scanners don't have to click back.
    // This helps them maintain a high scanning speed.
    if (loading === false && loadingSort === false) {
      inputRef?.current?.focus()
    }
  }, [loading, loadingSort])

  if (!connectedMarketAccount) {
    return (
      <div className="container">
        <LinkAmazonAccountWarning />
      </div>
    )
  }

  return (
    <div className="container">
      <h2 className="bp3-heading">Welcome back, {config.user.username}</h2>

      <div className="amazon-book-search-container">
        <div className="amazon-book-search-input-section">
          <AmazonBookSearchInput
            ref={inputRef}
            value={query}
            onChange={handleQueryChange}
            onSearch={handleSearch}
            loading={loading}
            loadingSort={loadingSort}
            inputquery={inputquery}
            sortDecision={sortDecision}
            description="Scan/enter ISBN barcode or search by title"
          />
        </div>

        {!loading && books.length > 0 && (
          <div className="amazon-book-search-results-section">
            <AmazonBookResults
              books={books}
              setSelectedBookIndex={handleSelectBook}
              selectedBookIndex={selectedBookIndex}
            />
          </div>
        )}

        {!loading && inputquery && books.length === 0 && (
          <div className="amazon-book-search-results-section">
            <h3>Search results</h3>
            <div className="amazon-book-empty-state">
              <div className="amazon-book-empty-card">No results found</div>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default ScanBooks
